// Auto-generated by tools/generate-design-tokens/generate-design-tokens.ts
// Re-run the generator after updating design-tokens.json. Do not edit manually.
// CSS custom properties that differ between the CallRail and white-label themes.
export const WL_THEME_OVERRIDE_VARS = [
  '--color-surface-emphasis-subtle',
  '--color-surface-emphasis-subtle-hover',
  '--color-surface-selected',
  '--color-surface-selected-hover',
  '--color-surface-control-selected',
  '--color-surface-control-selected-hover',
  '--color-surface-tooltip',
  '--color-surface-calendar-range',
  '--color-surface-calendar-range-boundary',
  '--color-surface-calendar-hover',
  '--color-foreground-selected',
  '--color-foreground-selected-hover',
  '--color-border-focus',
  '--color-border-selected',
  '--color-border-selected-subtle',
  '--color-border-selected-subtle-hover',
  '--color-border-emphasis',
  '--color-border-emphasis-subtle',
  '--color-border-emphasis-subtle-hover',
  '--color-action-primary-bg',
  '--color-action-primary-bg-hover',
  '--color-action-secondary-fg',
  '--color-action-secondary-bg-hover',
  '--color-action-secondary-border',
  '--color-action-secondary-border-hover',
  '--color-action-ghost-primary-fg',
  '--color-action-ghost-primary-fg-hover',
  '--color-action-ghost-secondary-fg-hover',
  '--color-action-inline-fg',
  '--color-action-inline-fg-hover',
  '--color-status-progress-fg',
  '--color-status-progress-fg-subtle',
  '--color-navigation-global-item-border-active',
  '--color-navigation-top-item-border-active',
  '--color-navigation-top-item-border-hover',
  '--color-navigation-side-item-fg',
  '--color-navigation-side-item-bg-hover',
  '--color-navigation-side-item-bg-active',
  '--color-navigation-tab-border-active',
  '--color-domain-brand',
  '--color-domain-classification-agent',
  '--color-domain-classification-customer',
  '--color-domain-classification-key-terms-bg',
  '--color-domain-classification-key-terms-active-bg',
  '--typography-primitives-leading-subheader',
  '--typography-primitives-font-weight-subheader',
] as const;
